import { render } from "./NewRegistersChart.vue?vue&type=template&id=4e4eac2f&ts=true"
import script from "./NewRegistersChart.vue?vue&type=script&lang=ts"
export * from "./NewRegistersChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__